import React from 'react';
import { motion } from 'framer-motion';

export default function TestimonialsSection({ t, testimonialsData, language }) {
  return (
    <section className="w-full bg-[#f7f5f0] py-10 md:py-14">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <h2 className="text-3xl md:text-4xl font-playfair text-center mb-10 md:mb-12 text-[#181c24] font-semibold leading-tight">
          {t.testimonials.loveStories}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 justify-center items-stretch">
          {testimonialsData[language].map((testimonial, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.7, delay: i * 0.15 }}
              className="flex flex-col items-center text-center bg-white p-4 md:p-5 shadow-xl rounded-lg">
              <img
                src={testimonial.photo}
                alt={testimonial.author}
                className="w-16 h-16 object-cover rounded-full mb-3 border-2 border-[#bfa76a]/50 shadow-md" />
              <blockquote className="text-base font-playfair text-[#181c24] mb-3 leading-relaxed">"{testimonial.quote}"</blockquote>
              <div className="text-xs text-[#bfa76a] font-semibold mb-0.5 font-playfair tracking-wide">{testimonial.author}</div>
              <div className="text-xs text-[#181c24]/70 font-playfair font-light">{testimonial.location}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
} 